/* ============================================================
   COVRFLY — Menu Móvil Premium v17.7 · Shopify Permanent
   ARCHITECTURE: "Body Portal" (consensus GPT + Gemini + Claude)
   Audited: 6 rounds, 16 fixes
   ============================================================ */

(function () {
  'use strict';

  /* ========= REVERT SYSTEM (v17.5 AUDITED) ========= */
  window.cfMenuRevert = function () {
    var S = window.__cfm17_state;
    if (!S) return;
    try {
      if (S.searchTimer) clearTimeout(S.searchTimer);
      if (S.searchAbort) { try { S.searchAbort.abort(); } catch (e) {} }

      document.getElementById('cfm17-root')?.remove();

      if (S.listeners?.length) {
        S.listeners.forEach(function (o) {
          try { o.target?.removeEventListener(o.type, o.fn, o.opts); } catch (e) {}
        });
      }
      if (S.drawerChildren) {
        S.drawerChildren.forEach(function (o) { if (o.el?.style) o.el.style.display = o.display; });
      }
      if (S.mutations) {
        S.mutations.forEach(function (o) {
          if (!o.el?.style) return;
          if (o.value == null) o.el.style.removeProperty(o.prop);
          else o.el.style.setProperty(o.prop, o.value, o.priority || '');
        });
      }
      if (S.backdrops) {
        S.backdrops.forEach(function (o) { if (o.el) o.el.style.cssText = o.css || ''; });
      }
      if (S.bodyLock) {
        var b = S.bodyLock;
        document.body.style.overflow = b.overflow;
        document.body.style.position = b.position;
        document.body.style.top = b.top;
        document.body.style.width = b.width;
        document.documentElement.style.overscrollBehavior = b.osb;
        var prevSB = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo(0, b.scrollY);
        document.documentElement.style.scrollBehavior = prevSB;
      }
      if (S.focusRestoreEl?.focus) {
        try { S.focusRestoreEl.focus({ preventScroll: true }); } catch (e) {}
      }
    } catch (e) { console.warn('[COVRFLY] revert error', e); }
    finally { window.__cfm17_state = null; }
  };

  /* ========= OPEN FUNCTION ========= */
  function cfMenuOpen() {
    if (typeof window.cfMenuRevert === 'function') window.cfMenuRevert();

    /* ========= FIND SHOPIFY DRAWER ========= */
    var header = document.querySelector('.offcanvas-header')
      || document.querySelector('.header__menu_drawer')
      || document.querySelector('details[open] > div');
    if (!header) { console.error('[COVRFLY] No drawer header found'); return; }
    var offcanvas = header.closest('.offcanvas') || header.closest('details') || header.parentElement;
    var origClose = header.querySelector('.offcanvas__close_btn')
      || header.querySelector('button[aria-label="Close"]')
      || header.querySelector('summary')
      || offcanvas?.querySelector('.offcanvas__close_btn')
      || document.querySelector('[data-close],.offcanvas__close_btn,button[aria-label="Close"]');

    /* ========= STATE TRACKING (v17.5) ========= */
    var state = {
      drawerChildren: [], mutations: [], backdrops: [],
      bodyLock: null, listeners: [],
      focusRestoreEl: document.activeElement,
      searchTimer: null, searchAbort: null, closing: false
    };
    window.__cfm17_state = state;

    var on = function (target, type, fn, opts) {
      if (!target) return;
      target.addEventListener(type, fn, opts);
      state.listeners.push({ target: target, type: type, fn: fn, opts: opts });
    };

    var mut = function (el, prop, val, pri) {
      if (!el?.style) return;
      state.mutations.push({ el: el, prop: prop, value: el.style.getPropertyValue(prop) || null, priority: el.style.getPropertyPriority(prop) || '' });
      if (val == null) el.style.removeProperty(prop);
      else el.style.setProperty(prop, val, pri || '');
    };

    /* R4-1: XSS escape helpers */
    var esc = function (s) { return String(s ?? '').replace(/[&<>"']/g, function (t) { return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[t]; }); };
    var safeUrl = function (u) { var s = String(u ?? ''); return (s.startsWith('/') || s.startsWith('https://')) ? s : '#'; };
    /* R5-1: Sanitize collection handles for href attributes */
    var safeHandle = function (h) { return String(h ?? '').toLowerCase().trim().replace(/[^a-z0-9-]/g, ''); };
    /* R6-1: Safe CSS url() — quotes + escapes " to prevent style injection */
    var cssUrl = function (u) { return "url('" + safeUrl(String(u ?? '')).replace(/'/g, '%27') + "')"; };

    /* Hide drawer children */
    Array.from(header.children).forEach(function (c) {
      state.drawerChildren.push({ el: c, display: c.style.display });
      c.style.display = 'none';
    });

    if (offcanvas) {
      mut(offcanvas, 'background', 'transparent', 'important');
      mut(offcanvas, 'box-shadow', 'none', 'important');
      mut(offcanvas, 'overflow', 'visible', 'important');
      mut(offcanvas, 'pointer-events', 'none', 'important');
    }

    document.querySelectorAll('.offcanvas-backdrop,.offcanvas-overlay,.drawer__overlay,.modal-overlay').forEach(function (bd) {
      state.backdrops.push({ el: bd, css: bd.style.cssText });
      bd.style.opacity = '0';
      bd.style.pointerEvents = 'none';
    });

    /* ========= SCROLL LOCK ========= */
    var scrollY = window.scrollY || 0;
    state.bodyLock = {
      scrollY: scrollY,
      overflow: document.body.style.overflow,
      position: document.body.style.position,
      top: document.body.style.top,
      width: document.body.style.width,
      osb: document.documentElement.style.overscrollBehavior
    };
    document.documentElement.style.overscrollBehavior = 'none';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';

    on(document, 'touchmove', function (e) {
      var root = document.getElementById('cfm17-root');
      if (!root) return;
      if (!e.target.closest('.cfm17-bd,.cfm17-sr')) e.preventDefault();
    }, { passive: false });

    /* ========= ASSETS ========= */
    var creaGIF = 'https://cdn.shopify.com/s/files/1/0741/3510/9868/files/covrfly-crea-tu-propia-funda-ezgif.com-gif-to-webp-converter.webp?v=1772002034';
    var HERO = ['best-sellers', 'new-drops'];
    var resize = function (u, w) { return u ? (u.includes('?') ? u + '&width=' + w : u + '?width=' + w) : ''; };

    var SVG = {
      close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
      search: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="9.2" cy="9.2" r="7"/><line x1="14.2" y1="14.2" x2="18" y2="18" stroke-linecap="round"/></svg>',
      user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
      back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>',
      chevron: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>',
      arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
      pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>'
    };

    /* ========= HTML ========= */
    var defResults = '<div class="cfm17-sr-label">Populares</div>' +
      '<a href="/collections/best-sellers" class="cfm17-sr-item" role="listitem"><span class="cfm17-sr-ico">' + SVG.search + '</span><span class="cfm17-sr-txt">Best Sellers</span></a>' +
      '<a href="/collections/new-drops" class="cfm17-sr-item" role="listitem"><span class="cfm17-sr-ico">' + SVG.search + '</span><span class="cfm17-sr-txt">New Drops</span></a>' +
      '<a href="/collections/the-gallery" class="cfm17-sr-item" role="listitem"><span class="cfm17-sr-ico">' + SVG.search + '</span><span class="cfm17-sr-txt">The Gallery</span></a>' +
      '<a href="/collections/pet-club" class="cfm17-sr-item" role="listitem"><span class="cfm17-sr-ico">' + SVG.search + '</span><span class="cfm17-sr-txt">Pet Club</span></a>' +
      '<a href="/collections/no-filter" class="cfm17-sr-item" role="listitem"><span class="cfm17-sr-ico">' + SVG.search + '</span><span class="cfm17-sr-txt">No Filter</span></a>';

    var root = document.createElement('div');
    root.id = 'cfm17-root';
    root.setAttribute('role', 'presentation');
    root.innerHTML =
      '<div id="cfm17-scrim" aria-hidden="true"></div>' +
      '<div class="cfm17-panel" role="dialog" aria-modal="true" aria-label="Menú de navegación">' +
        '<div class="cfm17-sv" id="cfm17-sv">' +
          '<div class="cfm17-sh"><button class="cfm17-sh-back" id="cfm17-back" aria-label="Volver al menú">' + SVG.back + '</button><input type="text" class="cfm17-sh-input" id="cfm17-input" placeholder="Buscar fundas, diseños..." autocomplete="off" autocorrect="off" spellcheck="false" aria-label="Buscar productos"/></div>' +
          '<div class="cfm17-sr" id="cfm17-results" role="list">' + defResults + '</div>' +
        '</div>' +

        '<div class="cfm17-topbar">' +
          '<button class="cfm17-btn" id="cfm17-x" aria-label="Cerrar menú">' + SVG.close + '</button>' +
          '<div class="cfm17-srch" id="cfm17-srch" role="button" tabindex="0" aria-label="Buscar fundas y diseños">' + SVG.search + '<span>Buscar fundas, diseños...</span></div>' +
          '<a class="cfm17-btn" href="/customer_authentication/redirect" aria-label="Mi cuenta">' + SVG.user + '</a>' +
        '</div>' +

        '<div class="cfm17-sticky cfm17-an cfm17-d1">' +
          '<a href="/apps/parcelpanel" class="cfm17-track" aria-label="Rastrea tu pedido">' +
            '<div class="cfm17-track-top">' +
              '<div class="cfm17-track-ico">' +
                '<div class="cfm17-track-live"></div>' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"><path d="M16.5 9.4L7.5 4.21"/><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22" x2="12" y2="12"/></svg>' +
              '</div>' +
              '<div class="cfm17-track-txt">' +
                '<div class="cfm17-track-title">Rastrea tu pedido</div>' +
                '<div class="cfm17-track-sub">Tu envío, en tiempo real</div>' +
              '</div>' +
            '</div>' +
            '<div class="cfm17-track-route">' +
              '<div class="cfm17-track-progress"><div class="cfm17-track-progress-fill"></div></div>' +
              '<div class="cfm17-track-labels"><span>Enviado</span><span>En camino</span><span>Entregado</span></div>' +
            '</div>' +
          '</a>' +
        '</div>' +

        '<div class="cfm17-bd">' +
          '<div class="cfm17-cards cfm17-an cfm17-d2">' +
            '<a href="/collections/best-sellers" class="cfm17-card cfm17-card--hero" aria-label="Best Sellers"><div class="cfm17-card-bg ld" id="cfm17-h0"></div></a>' +
            '<div class="cfm17-card-row">' +
              '<a href="/collections/new-drops" class="cfm17-card cfm17-card--sm" aria-label="New Drops"><div class="cfm17-card-bg ld" id="cfm17-h1"></div></a>' +
              '<a href="/products/covrfly" class="cfm17-card cfm17-card--sm cfm17-card--gif" aria-label="Personaliza tu funda"><div class="cfm17-card-bg" style="background-image:url(' + creaGIF + ')"></div></a>' +
            '</div>' +
          '</div>' +

          '<div class="cfm17-label cfm17-an cfm17-d3">Colecciones</div>' +
          '<div class="cfm17-cg cfm17-an cfm17-d3" id="cfm17-grid" role="list"></div>' +

          '<div class="cfm17-promo cfm17-an cfm17-d4">' +
          '<div class="cfm17-promo-glow"></div>' +
          '<div class="cfm17-promo-sweep"><div class="cfm17-promo-sweep-inner"></div></div>' +
          '<div class="cfm17-promo-sub">Compra 2 o más</div>' +
          '<div class="cfm17-promo-hero">hasta 25% <span class="cfm17-promo-off">OFF</span></div>' +
          '<div class="cfm17-promo-free"><div class="cfm17-promo-dot"></div><span>envío sin costo</span></div>' +
          '<div class="cfm17-promo-sep"></div>' +
          '<div class="cfm17-promo-tiers">' +
          '<div class="cfm17-tier cfm17-tier--1"><div class="cfm17-tier-pct">15%</div><div class="cfm17-tier-qty">2</div></div>' +
          '<div class="cfm17-tier cfm17-tier--2"><div class="cfm17-tier-pct">20%</div><div class="cfm17-tier-qty">3</div></div>' +
          '<div class="cfm17-tier cfm17-tier--3"><div class="cfm17-tier-badge">mejor</div><div class="cfm17-tier-pct">25%</div><div class="cfm17-tier-qty">4+</div></div>' +
          '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.appendChild(root);

    /* ========= TRACKING CARD: FADE + SHRINK + COLLAPSE ON SCROLL ========= */
    requestAnimationFrame(function () {
      var scrollPanel = document.querySelector('.cfm17-bd');
      var card = document.querySelector('a.cfm17-track, .cfm17-track');

      if (!scrollPanel || !card) return;

      var fullHeight = card.offsetHeight;
      if (fullHeight === 0) return;

      var collapsedHeight = Math.round(fullHeight * 0.55);
      var fadeDistance = 35;

      card.style.maxHeight = fullHeight + 'px';

      scrollPanel.addEventListener('scroll', function () {
        var st = scrollPanel.scrollTop;

        if (st <= 2) {
          card.style.opacity = '1';
          card.style.transform = 'scale(1)';
          card.style.maxHeight = fullHeight + 'px';
          card.style.marginBottom = '';
        } else if (st <= fadeDistance) {
          var p = st / fadeDistance;
          card.style.opacity = String(1 - (p * 0.7));
          card.style.transform = 'scale(' + (1 - (p * 0.12)) + ')';
          card.style.maxHeight = (fullHeight - (p * (fullHeight - collapsedHeight))) + 'px';
          card.style.marginBottom = (p * -10) + 'px';
        } else {
          card.style.opacity = '0.3';
          card.style.transform = 'scale(0.88)';
          card.style.maxHeight = collapsedHeight + 'px';
          card.style.marginBottom = '-10px';
        }
      });
    });

    /* ========= CLOSE WITH EXIT ANIMATION (R4-5: revert timing) ========= */
    var doClose = function () {
      if (state.closing) return;
      state.closing = true;

      var panel = document.querySelector('.cfm17-panel');
      var scrim = document.getElementById('cfm17-scrim');
      if (panel) panel.classList.add('is-closing');
      if (scrim) scrim.classList.add('is-closing');

      setTimeout(function () {
        try {
          if (origClose) { origClose.style.display = ''; origClose.click(); origClose.style.display = 'none'; }
          else document.querySelector('.offcanvas__close_btn,[data-close],button[aria-label="Close"]')?.click();
        } catch (e) { console.warn('[COVRFLY] close error', e); }

        /* R4-5: Let Shopify update DOM/state before revert */
        requestAnimationFrame(function () { setTimeout(function () { window.cfMenuRevert(); }, 30); });
      }, 300);
    };

    on(document.getElementById('cfm17-x'), 'click', doClose);

    on(document.getElementById('cfm17-scrim'), 'click', function () {
      var sv = document.getElementById('cfm17-sv');
      if (sv?.classList.contains('active')) {
        sv.classList.remove('active');
        try { document.getElementById('cfm17-srch')?.focus({ preventScroll: true }); } catch (e) {}
        return;
      }
      doClose();
    });

    /* ESC + Focus trap */
    on(window, 'keydown', function (e) {
      if (e.key === 'Escape') {
        var sv = document.getElementById('cfm17-sv');
        if (sv?.classList.contains('active')) {
          sv.classList.remove('active');
          try { document.getElementById('cfm17-srch')?.focus({ preventScroll: true }); } catch (e2) {}
        } else { doClose(); }
        return;
      }

      /* R4-3: Focus trap filters invisible elements */
      if (e.key === 'Tab') {
        var panel = document.querySelector('.cfm17-panel');
        if (!panel) return;
        var focusable = Array.from(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'))
          .filter(function (el) { return el.offsetWidth > 0 && el.offsetHeight > 0 && window.getComputedStyle(el).visibility !== 'hidden'; });
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        /* R5-2: Catch focus that escaped the panel (Safari, timing, widgets) */
        if (!panel.contains(document.activeElement)) {
          e.preventDefault();
          (e.shiftKey ? last : first).focus({ preventScroll: true });
          return;
        }
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus({ preventScroll: true });
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus({ preventScroll: true });
        }
      }
    });

    /* ========= SEARCH SUBVIEW ========= */
    var sv = document.getElementById('cfm17-sv');
    var inp = document.getElementById('cfm17-input');
    var res = document.getElementById('cfm17-results');

    var openSearch = function () {
      sv.classList.add('active');
      setTimeout(function () { inp.value = ''; inp.focus({ preventScroll: true }); }, 250);
      if (res) res.innerHTML = defResults;
    };

    on(document.getElementById('cfm17-srch'), 'click', openSearch);

    /* R4-4: Search pill responds to Enter/Space */
    on(document.getElementById('cfm17-srch'), 'keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openSearch();
      }
    });

    on(document.getElementById('cfm17-back'), 'click', function () {
      inp.value = ''; inp.blur(); sv.classList.remove('active');
      if (res) { res.innerHTML = defResults; res.classList.remove('cfm17-has-products', 'cfm17-one-result'); }
      try { document.getElementById('cfm17-srch')?.focus({ preventScroll: true }); } catch (e) {}
    });

    /* Predictive search — grid cards matching lupa header */
    on(inp, 'input', function () {
      clearTimeout(state.searchTimer);
      if (state.searchAbort) { try { state.searchAbort.abort(); } catch (e) {} }

      var q = inp.value.trim();
      if (q.length < 2) {
        res.innerHTML = defResults;
        res.classList.remove('cfm17-has-products', 'cfm17-one-result');
        return;
      }

      state.searchTimer = setTimeout(function () {
        if (!document.getElementById('cfm17-root')) return;

        state.searchAbort = new AbortController();
        fetch('/search/suggest?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=product&resources%5Blimit%5D=10&resources%5Boptions%5D%5Bfields%5D=title%2Ctag%2Cproduct_type%2Cbody&section_id=predictive-search', { signal: state.searchAbort.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            if (!document.getElementById('cfm17-root')) return;

            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var items = doc.querySelectorAll('.predictive-search__list-item');

            if (!items.length) {
              res.innerHTML = '<div class="cfm17-sr-label">Sin resultados</div><div style="color:#999;font-size:13px;padding:10px 0">No encontramos "' + esc(q) + '"</div>';
              res.classList.remove('cfm17-has-products', 'cfm17-one-result');
              return;
            }

            var cardsHtml = '<div class="cfm17-sr-label">RESULTADOS</div>';

            items.forEach(function (li) {
              var a = li.querySelector('a.predictive-search__item');
              if (!a) return;
              var href = safeUrl(a.getAttribute('href') || '#');

              var imgEl = li.querySelector('img.predictive-search__image');
              var imgSrc = imgEl ? imgEl.getAttribute('src').replace('_150x', '_500x') : '';
              var fullSrc = imgSrc.startsWith('//') ? 'https:' + imgSrc : imgSrc;

              var title = esc(li.querySelector('.predictive-search__item-heading')?.textContent?.trim() || '');

              var moneyEl = li.querySelector('.price-item--sale .money') || li.querySelector('.price-item .money') || li.querySelector('.money');
              var price = esc(moneyEl?.textContent?.trim() || '');

              cardsHtml += '<a href="' + href + '" class="cfm17-sr-item" role="listitem">' +
                (fullSrc ? '<img src="' + safeUrl(fullSrc) + '" alt="' + title + '"/>' : '') +
                '<span class="cfm17-sr-txt"><span class="cfm17-sr-title">' + title + '</span>' +
                (price ? '<span class="cfm17-sr-price">' + price + '</span>' : '') +
                '</span></a>';
            });

            res.innerHTML = cardsHtml;
            res.classList.add('cfm17-has-products');
            // Toggle clase para 1 solo resultado
            var productItems = res.querySelectorAll('.cfm17-sr-item');
            if (productItems.length === 1) {
              res.classList.add('cfm17-one-result');
            } else {
              res.classList.remove('cfm17-one-result');
            }
          })
          .catch(function (e) {
            if (e.name !== 'AbortError') console.warn('[COVRFLY] search error', e);
          });
      }, 300);
    });

    var srch = document.getElementById('cfm17-srch');
    setTimeout(function () { try { srch?.focus?.({ preventScroll: true }); } catch (e) {} }, 80);

    /* ========= COLLECTIONS ========= */
    var fetchWithTimeout = function (url, ms) {
      var ac = new AbortController();
      var t = setTimeout(function () { ac.abort(); }, ms);
      return fetch(url, { credentials: 'same-origin', signal: ac.signal })
        .finally(function () { clearTimeout(t); });
    };

    var collectionsPromise = prefetchedCollections
      ? Promise.resolve(prefetchedCollections)
      : fetchWithTimeout('/collections.json?limit=30', 4000).then(function (r) { return r.json(); });

    collectionsPromise.then(function (data) {
        if (!document.getElementById('cfm17-root')) return;
        var colls = data?.collections || [];
        var map = {};
        colls.forEach(function (c) { map[c.handle] = c; });

        HERO.forEach(function (h, i) {
          var el = document.getElementById('cfm17-h' + i);
          if (!el) return;
          var src = map[h]?.image?.src;
          if (src) el.style.backgroundImage = cssUrl(resize(src, 800));
          else el.style.background = 'linear-gradient(135deg,#1a1a2e,#333)';
          el.classList.remove('ld');
        });

        var grid = document.getElementById('cfm17-grid');
        if (grid) {
          var sub = colls.filter(function (c) { return !HERO.includes(c.handle); }).slice(0, 7);
          var gh = '';
          sub.forEach(function (c) {
            var src = c.image?.src;
            var handle = safeHandle(c.handle);
            /* R4-1: XSS — escape c.title in fallback */
            gh += src
              ? '<a href="/collections/' + handle + '" class="cfm17-co" role="listitem" aria-label="' + esc(c.title) + '"><div class="cfm17-co-bg" style="background-image:' + cssUrl(resize(src, 400)) + '"></div></a>'
              : '<a href="/collections/' + handle + '" class="cfm17-co" role="listitem" style="background:rgba(200,200,200,.5);display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#555;text-transform:uppercase">' + esc(c.title) + '</a>';
          });
          gh += '<a href="/collections" class="cfm17-vt" role="listitem" aria-label="Ver todas las colecciones"><div class="cfm17-vt-ico">' + SVG.arrow + '</div><span>Ver todas</span></a>';
          grid.innerHTML = gh;
        }
      }).catch(function (e) {
        if (e.name === 'AbortError') console.warn('[COVRFLY] collections fetch timeout (4s)');
        else console.warn('[COVRFLY] collections error', e);
      });
  }

  window.cfMenuOpen = cfMenuOpen;

  /* ========= PREFETCH COLLECTIONS ========= */
  var prefetchedCollections = null;

  function prefetchCollections() {
    fetch('/collections.json?limit=30', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(data) { prefetchedCollections = data; })
      .catch(function() {});
  }

  // Prefetch después de 1 segundo (no bloquear carga inicial de la página)
  setTimeout(prefetchCollections, 1000);

  /* ========= INTERCEPT HAMBURGER ========= */
  function initMenuIntercept() {
    document.addEventListener('click', function(e) {
      var el = e.target;
      while (el && el !== document) {
        if (el.classList && (el.classList.contains('header__actions_btn--menu') || (el.tagName === 'SUMMARY' && el.classList.contains('header__menu_item')))) break;
        el = el.parentElement;
      }
      if (!el || el === document) return;

      var attempts = 0;
      var maxAttempts = 50;
      var checkForDrawer = setInterval(function() {
        attempts++;
        if (document.querySelector('.offcanvas-header')) {
          clearInterval(checkForDrawer);
          if (typeof window.cfMenuOpen === 'function') {
            requestAnimationFrame(function() { window.cfMenuOpen(); });
          }
        }
        if (attempts >= maxAttempts) clearInterval(checkForDrawer);
      }, 10);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuIntercept);
  } else {
    initMenuIntercept();
  }
})();
